var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfiles(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.167 7.333a1.444 1.444 0 100-2.888 1.444 1.444 0 000 2.888zm10.11 0a1.444 1.444 0 100-2.889 1.444 1.444 0 000 2.89zm.723.723h-1.444c-.398 0-.759.317-1.019.837.91.997 1.553 2.803 1.697 4.94h1.488c.397 0 .722-.65.722-1.444v-1.445c0-1.588-.65-2.888-1.444-2.888zm-5.778 0a2.528 2.528 0 100-5.056 2.528 2.528 0 000 5.056zm1.734.722h-.188c-.47.375-.99.6-1.546.6s-1.076-.217-1.545-.6h-.188c-1.437 0-2.6 1.943-2.6 4.333v1.083c0 .997.484 1.806 1.083 1.806h6.5c.6 0 1.084-.809 1.084-1.806v-1.083c0-2.39-1.163-4.333-2.6-4.333zm-5.049.115c-.26-.52-.62-.837-1.018-.837H4.444C3.65 8.056 3 9.356 3 10.944v1.445c0 .794.325 1.444.722 1.444H5.21c.144-2.137.787-3.943 1.697-4.94z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default ForwardRef;